import { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TechBanner from './components/TechBanner';
import About from './components/About';
import Projects from './components/Projects';
import Blogs from './components/Blogs';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Preloader from './components/Preloader';

function App() {
  const [loading, setLoading] = useState(true);

  return (
    <div className={`min-h-screen bg-black star-bg relative overflow-x-hidden ${loading ? 'h-screen overflow-hidden' : ''}`}>
      <AnimatePresence>
        {loading && <Preloader onComplete={() => setLoading(false)} />}
      </AnimatePresence>

      {/* Subtle radial gradient overlay for depth */}
      <div className="fixed inset-0 pointer-events-none z-0"
        style={{
          background: 'radial-gradient(ellipse 80% 60% at 50% 0%, rgba(0,185,46,0.04) 0%, transparent 70%)'
        }}
      />
      <div className="relative z-10">
        <Navbar />
        <main>
          <Hero />
          <TechBanner />
          <About />
          <Projects />
          <Blogs />
          <Skills />
          <Contact />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;